<template>
    <div>
        <h1>批量产生二维码</h1>

        <!-- 二维码需要的信息表单 -->
        <el-form ref="bc_form" :model="form" :inline="false" :rules="rules">
            <el-form-item label="产品类别编码" prop="category">
                <el-select v-model="form.category" clearable placeholder="请选择产品类别">
                    <el-option v-for="item in categories" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="生产年份" prop="year">
                <el-date-picker v-model="form.year" type="year" value-format="yyyy" placeholder="请选择生产年份"></el-date-picker>
            </el-form-item>
            <el-form-item label="生产批次" prop="batch">
                <el-input-number v-model="form.batch" :min="1" :max="255" label="请输入生产批次" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="地区" prop="area">
                <el-select v-model="form.area" clearable placeholder="请选择地区">
                    <el-option v-for="item in areas" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="起始序号" prop="start">
                <el-input-number v-model="form.start" :min="1" :max="10000" label="请输入本批次第一个序号" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="计划生产数量" prop="quantity">
                <el-input-number v-model="form.quantity" :min="1" :max="10000" label="请输入本批次生产数量" :precision="0"></el-input-number>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="submit" type="primary" :loading="loading">生成二维码</el-button>
        </span>
        <div>
            <el-link :href="bc_link" target="_blank">{{bc_link_text}}</el-link>
        </div>
    </div>
</template>

<script>
import { getBarcodeUrl } from '@/api';

export default {
    data() {
        return {
            form: {
                category: '',
                year: '2024',
                batch: 1,
                area: '',
                start: '',
                quantity: ''
            },

            categories: [{
                value: 'be',
                label: '智能项圈'
            },{
                value: 'ce',
                label: '智能项圈2代'
            }],

            areas: [{
                value: 1,
                label: '中国'
            }],

            rules: {
                category: [
                    { required: true, message: '请选择产品类别' }
                ],
                year: [
                    { required: true, message: '请选择生产年份' }
                ],
                batch: [
                    { required: true, message: '请输入生产批次' }
                ],
                area: [
                    { required: true, message: '请选择地区' }
                ],
                start: [
                    { required: true, message: '请输入本批次第一个序号' }
                ],
                quantity: [
                    { required: true, message: '请输入生产数量' }
                ]
            },

            bc_link: '',
            bc_link_text: '',
            loading: false
        };
    },
    methods: {
        submit() {
            this.$refs.bc_form.validate((valid) => {
                console.log(valid);
                if (valid) {
                    this.loading = true
                    const form_data = {
                        category: this.form.category,
                        year: this.form.year,
                        batch: this.form.batch,
                        area: this.form.area,
                        start: this.form.start,
                        quantity: this.form.quantity
                    };
                    console.log(form_data, 'form');
                    getBarcodeUrl(form_data).then((data) => {
                        const bcResp = data.data
                        console.log("barcode response: " + bcResp.code);
                        if(bcResp.code != 200) {
                            this.bc_link_text = bcResp.msg + bcResp.code;
                        } else {
                            this.bc_link = 'https://api.chongyueyue.cn' + bcResp.data.barcode;
                            this.bc_link_text = this.bc_link;
                        }
                        this.loading = false;
                    })
                }
            })
        }
    }
}
</script>
